var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44582",
    "data-name": "Group 44582",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.314,
    height: 21.5,
    viewBox: "0 0 17.314 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44581",
    "data-name": "Group 44581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89214",
    "data-name": "Path 89214",
    d: "M14.721,9.538l.913-.212V7.058l-1.609-.374a6.018,6.018,0,0,0-.643-1.551l.874-1.4-1.6-1.6L11.25,3A6.022,6.022,0,0,0,9.7,2.359L9.326.75H7.058L6.684,2.359A6.036,6.036,0,0,0,5.133,3l-1.4-.873-1.6,1.6L3,5.133a5.981,5.981,0,0,0-.642,1.551L.75,7.058V9.326L2.359,9.7A5.967,5.967,0,0,0,3,11.251l-.873,1.4,1.6,1.6,1.4-.873",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89215",
    "data-name": "Path 89215",
    d: "M10.052,8.192a1.861,1.861,0,1,1-1.86-1.86A1.86,1.86,0,0,1,10.052,8.192Z",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89216",
    "data-name": "Path 89216",
    d: "M13.308,16.1a1.906,1.906,0,0,1-1.86-1.993v-.665a1.864,1.864,0,1,1,3.72,0v.665A1.906,1.906,0,0,1,13.308,16.1Z",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89217",
    "data-name": "Path 89217",
    d: "M10.983,16.684a5.212,5.212,0,0,1,2.325-.585c1.159,0,3.256.574,3.256,1.849v.476",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89218",
    "data-name": "Path 89218",
    d: "M7.727,18.424a1.906,1.906,0,0,1-1.86-1.993v-.665a1.906,1.906,0,0,1,1.86-1.993,1.906,1.906,0,0,1,1.86,1.993v.665A1.906,1.906,0,0,1,7.727,18.424Z",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89219",
    "data-name": "Path 89219",
    d: "M4.471,20.75v-.465c0-1.275,2.1-1.861,3.256-1.861s3.256.575,3.256,1.85v.476",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon1);
export default __webpack_public_path__ + "static/media/settings-icon1.3264a2335737e41afd3539f914466f80.svg";
export { ForwardRef as ReactComponent };